import {Gutter} from 'antd/es/grid/row';

export const rowGutter: [Gutter, Gutter] = [16, 8];
